module.exports = __webpack_public_path__ + "img/chess_gowhite.1a4a3573.png";